export default "__VITE_ASSET__COIg4YSX__"